import React from 'react'

export default function Footer() {
	return (
		<footer className="footer">
			<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold"><b>Cubepost Services</b> and <b>IPFindable.io</b></span> All rights reserved.</span>
			<div>
				<a className="text-gray" href="https://ipfindable.io/terms-and-conditions">Terms & Conditions</a>
				<span className="mx-2 text-muted"> | </span>
				<a className="text-gray" href="https://ipfindable.io/terms-and-conditions#privacy-policy">Privacy Policy</a>
			</div>
		</footer>
	)
}

